import dayjs from 'dayjs';

// 日期转换
export default class DateConverter {
  type = 'date';

  toQuery(item) {
    const must = [];
    const { formData, columnInfo } = item;
    if (columnInfo.type !== this.type) {
      return;
    }
    const columnKey = `${columnInfo.columnKey}`;
    let queryItem = { range: { [columnKey]: {} } };
    const index = must.findIndex(mustItem => {
      return Object.prototype.hasOwnProperty.bind(mustItem.range)(columnKey);
    });
    if (index > -1) {
      queryItem = must[index];
    } else {
      must.push(queryItem);
    }
    if (formData.date[0]) {
      const gteDate = dayjs(formData.date[0]).valueOf();
      queryItem.range[columnKey].gte = gteDate;
    }
    if (formData.date[1]) {
      const ltDate = dayjs(formData.date[1])
        .add(1, 'day')
        .valueOf();
      queryItem.range[columnKey].lt = ltDate;
    }
    return { must, must_not: [] };
  }
}
